import { useEffect, useState } from "react";
import axios from "axios";
import { Medal } from "lucide-react";
import { API } from "@/lib/auth";
import { money } from "@/components/market/Shared";

export const Leaderboard = () => {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/leaderboard`).then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  return (
    <section className="glass p-5 space-y-3" data-testid="leaderboard">
      <h2 className="font-head font-semibold flex items-center gap-2"><Medal className="w-4 h-4 text-amber-300" />Weekly leaderboard</h2>
      <p className="text-xs text-slate-500">{d.note}</p>
      {d.rows.length === 0 ? <p className="text-sm text-slate-400" data-testid="leaderboard-empty">No finished practice bets this week yet. Be the first on the board.</p> :
        <div className="divide-y divide-[var(--line)]">{d.rows.map((r) => (
          <div key={r.rank} className="flex items-center gap-3 py-2 text-sm" data-testid={`leaderboard-row-${r.rank}`}>
            <span className={`w-6 font-num font-bold ${r.rank <= 3 ? "text-amber-300" : "text-slate-500"}`}>{r.rank}</span>
            <span className="flex-1 truncate">{r.name}</span>
            <span className="text-[11px] text-slate-500 font-num">{r.wins}/{r.bets} wins{r.streak > 1 ? ` · ${r.streak}🔥` : ""}</span>
            <span className={`font-num ${r.pnl >= 0 ? "text-emerald-300" : "text-red-300"}`}>{r.pnl >= 0 ? "+" : ""}{money(r.pnl, 2)}</span>
          </div>))}</div>}
    </section>
  );
};
